import React, { useEffect } from "react";
import { Form, Row, Col } from "antd";
import BannerCard from "../../../common/components/BannerCard";
import InputCurrency from "../../../common/components/InputCurrency";

const CasePaymentsBonds = ({ ...props }) => {
  const { form, caseMaster } = props;

  useEffect(() => {
    const paymentData = caseMaster?.payments?.MAIN[0];
    form.setFieldsValue({ ...paymentData });
  }, [caseMaster?.payments?.MAIN, form]);

  return (
    <BannerCard title="Bond Details">
      <Form form={form} layout="vertical">
        <Row gutter={16}>
          <Col xl={12} lg={12} md={12} sm={12} xs={24}>
            <Form.Item name="BONDS_RECEIVED" label="Bonds Received">
              <InputCurrency style={{ width: "100%" }} readOnly />
            </Form.Item>
          </Col>
          <Col xl={12} lg={12} md={12} sm={12} xs={24}>
            <Form.Item name="BONDS_DISTRIBUTED" label="Bonds Distributed">
              <InputCurrency style={{ width: "100%" }} readOnly />
            </Form.Item>
          </Col>
          <Col xl={12} lg={12} md={12} sm={12} xs={24}>
            <Form.Item name="BONDS_RECEIVED" label="Net Bond Balance">
              <InputCurrency style={{ width: "100%" }} readOnly />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </BannerCard>
  );
};

export default CasePaymentsBonds;
